import { API_URL } from './Config';
import { startLoading, endLoading, SnackBar, handleHTTPError, ShowLoadingSpinner, pageGifLoader } from './CommonActions';
import store from '../store';
import axios from 'axios';

export function storeMaldiveTourFilters(list) {
    return {
        type: 'STORE_MALDIVE_TOUR_FILTERS',
        list: list.data
    }
}

export function getMaldiveTourFilters() {
    return function (dispatch) {
        dispatch(startLoading());
        dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/maldive-tours/filters', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeMaldiveTourFilters(json));
                    if (json.success) {
                        dispatch(getMaldiveTourList());
                    }
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function stoteMaldiveTourDetailsUpdate(bool) {
    return {
        type: 'STORE_MALDIVE_TOUR_DETAILS_UPDATE', bool
    }
}

export function storeMaldiveTourList(list) {
    return {
        type: 'STORE_MALDIVE_TOUR_LISTS',
        list: list.data
    }
}

export function clearMaldiveTourList() {
    return { type: 'CLEAR_MALDIVE_TOUR_LISTS' }
}

export function getMaldiveTourList(search = "", type = "", rate = "", price = "") {
    return function (dispatch) {
        dispatch(pageGifLoader(true));
        dispatch(clearMaldiveTourList());
        fetch(API_URL + '/api/maldive-tours/list?key=' + search + "&type=" + type + "&rating=" + rate + "&price_range=" + price+ "&id=" + 0 , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(pageGifLoader(false));

                    if (json.success && json.data.tours.length > 0) {
                        dispatch(getMaldiveTourListMore(search, type, rate, price, json.data.tours[json.data.tours.length - 1].id, false));
                    }
                    
                    dispatch(storeMaldiveTourList(json));
                });
            }).catch((error) => {
                dispatch(pageGifLoader(false));
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function updateMaldiveTourListArray(bool) {
    return {
        type: 'UPDATE_MALDIVE_TOUR_LIST_ARRAY', bool
    }
}


export function updateMaldiveTourList(data) {
    return {
        type: 'UPDATE_MALDIVE_MORE_TOUR_LISTS',
        list: data
    }
}

export function getMaldiveTourListMore(search = "", type = "", rate = "", price = "", id , loader = false) {
    return function (dispatch) {
        dispatch(pageGifLoader(loader));
        dispatch(updateMaldiveTourListArray(false));
        fetch(API_URL + '/api/maldive-tours/listmore?key=' + search + "&type=" + type + "&rating=" + rate + "&price_range=" + price + "&id=" + id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(pageGifLoader(false));
                    dispatch(updateMaldiveTourListArray(json.success && json.data.tours.length > 0));
                    dispatch(updateMaldiveTourList(json.data));
                });
            }).catch((error) => {
                dispatch(pageGifLoader(false));
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}